/**
 * Audit severity vocabulary (CT-4184) — a THIRD vocabulary, distinct from
 * integration health (CT-4195 `STATUS_BADGE_VARIANT`) and request status
 * (CT-4200). Defined once here and shared with Global Audit (CT-3901/CT-4210).
 */
export const AUDIT_SEVERITY = {
  CRIT: 'crit',
  WARN: 'warn',
  INFO: 'info',
};

/** severity → @aimsos/ui Badge variant. */
export const AUDIT_SEVERITY_VARIANT = {
  crit: 'danger',
  warn: 'warning',
  info: 'informative',
};

/** i18n label key for an audit severity. */
export const auditSeverityLabelKey = (severity) =>
  `integrations.audit.severity.${severity ?? 'info'}`;

export const AUDIT_SEVERITY_ORDER = ['crit', 'warn', 'info'];
